import { createSelector } from 'reselect';

import { getEntity } from 'modules/entity/selectors';
import type { AnsweredAudit, ResponseTypes } from 'modules/entity/subEntities/audit/types';

const getProps = (_state: unknown, props: string) => props;

export const getAudits = createSelector(getEntity, ({ checklists = [] }) =>
  Object.values(
    checklists.reduce<Record<string, AnsweredAudit>>((acc, { originAudit }) => {
      if (originAudit) {
        acc[originAudit.id] = originAudit;
      }
      return acc;
    }, {})
  ));

const getResponsesById = createSelector(getAudits, (audits) =>
  audits.reduce<Record<string, ResponseTypes>>((acc, { sections = [] }) => {
    sections
      .flatMap(({ questions = [] }) => questions)
      .forEach((question) => {
        acc[question.id] = question;
      });
    return acc;
  }, {}));

export const getResponseById = createSelector(getProps, getResponsesById, (id, responses) => responses[id]);
